import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'Services/Features/User/Utils/userUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindUser from './Filter/FindUser';
import UserTable from './UserTable';

const UserContain = () => {
    const dispatch = useDispatch();
    const users = useSelector((state) => state.user.users);
    const loading = useSelector((state) => state.user.loading);
    const error = useSelector((state) => state.user.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.user.filters);

    useEffect(() => {
        dispatch(getUser(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindUser />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && users.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Pengguna Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <UserTable setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default UserContain;